import { Award, Gauge, HeartHandshake, ShieldCheck } from "lucide-react";
import { FadeUp, SectionHead } from "../Reveal";

const VALUES = [
  {
    icon: Award,
    title: "Kalite",
    desc: "Sağlam malzeme, özenli imalat ve uzun ömürlü makineler.",
  },
  {
    icon: ShieldCheck,
    title: "Güven",
    desc: "Verdiğimiz sözü tutar, arkamızda dururuz.",
  },
  {
    icon: Gauge,
    title: "Verimlilik",
    desc: "Zamanı, yakıtı ve emeği verimli kullanan çözümler.",
  },
  {
    icon: HeartHandshake,
    title: "Müşteri Memnuniyeti",
    desc: "İhtiyacınıza uygun doğru makine ve yakından takip.",
  },
];

export default function About() {
  return (
    <section id="hakkimizda" className="relative scroll-mt-24 bg-paper py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <SectionHead
              eyebrow="Hakkımızda"
              title="Baytaş Tarım"
              desc="Baytaş Tarım, tarım makineleri alanında faaliyet gösteren, çiftçinin sahadaki ihtiyacını iyi bilen bir üretim ve çözüm ortağıdır. Kaliteli malzeme, sağlam imalat ve uzun ömürlü makinelerle çalışır."
            />
            <FadeUp delay={0.2}>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-soil sm:text-lg">
                Kültüvatörden goble&apos;ye, diskarodan kaldıraça kadar toprak işleme zincirinin her
                halkasında, zamanı ve emeği verimli kullanan makineler üretiyoruz. Amacımız sadece
                makine üretmek değil; üretiminize değer katmak.
              </p>
            </FadeUp>
            <FadeUp delay={0.28}>
              <a href="#iletisim" onClick={(e) => { e.preventDefault(); window.__scrollToHash?.("iletisim"); }} className="btn btn-dark mt-8" data-testid="about-contact-btn">
                Bize Ulaşın
              </a>
            </FadeUp>
          </div>

          <div className="lg:col-span-7">
            <div className="grid gap-6 sm:grid-cols-2">
              {VALUES.map((value, i) => (
                <FadeUp key={value.title} delay={0.08 * i} className="h-full">
                  <div
                    className="card h-full p-6 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-ink/40 hover:shadow-[0_18px_40px_-20px_rgba(18,26,20,0.25)]"
                    data-testid={`about-value-${i}`}
                  >
                    <span className="grid h-11 w-11 place-items-center rounded-md border border-gold/30 bg-gold/15 text-gold">
                      <value.icon size={20} />
                    </span>
                    <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-tight text-ink">
                      {value.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-soil">{value.desc}</p>
                  </div>
                </FadeUp>
              ))}
            </div>
            <FadeUp delay={0.2}>
              <figure className="mt-6 overflow-hidden rounded-lg border border-line">
                <img
                  src="https://images.unsplash.com/photo-1698025594761-39e52299b9a7?auto=format&fit=crop&w=1600&q=80"
                  alt="Baytaş Tarım makinesi tarlada çalışırken havadan görünüm"
                  loading="lazy"
                  className="h-56 w-full object-cover sm:h-72"
                />
              </figure>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}